import "./ThinksToDo.scss";
import {
  InvoiceCountIcon,
  LikeIcon,
} from "../../assets/images";
import BoxLoader from "../commons/BoxLoader/BoxLoader";
import { formatDate, getFinancialYearDates } from "../../utils/commonFunctions";
import moment from "moment";
import { UnApprovedInvoiceCountDataListType } from "../../redux/thinksToDo/thinksToDoType";

type AppProps = {
  unApprovedInvoiceCountData: UnApprovedInvoiceCountDataListType[]|[];
  thinksToDoFetching: boolean;
  history: any;
};
const ShowInvoiceCountAccountInChargeModal = ({
  unApprovedInvoiceCountData,
  thinksToDoFetching,
  history,
}: AppProps) => {

  const { startDate, endDate } = getFinancialYearDates();
  const today = new Date();
  let countDate :any;
  countDate = new Date(today);
  countDate.setDate(countDate.getDate() - 4);
  return (
    <div
      className="boxs scheduled-upcoming-interviews"
      style={{ overflow: "auto" }}
    >
      {thinksToDoFetching ? (
        <BoxLoader style={{ height: "100%" }} />
      ) : (
        <>
          <div className="d-flex justify-content-between">
            <div
              className="p-4 d-flex align-items-center w-75"
              style={{ gap: "3%" }}
            >
              <div>
                <img src={InvoiceCountIcon} alt="user icon" />
              </div>
              <div>
                <p className="m-0" style={{ color: "#7c8db0" }}>
                  INVOICE ENTRIES WITH PENDING APPROVALS
                </p>
                <p
                  className="m-0"
                  style={{ fontSize: "14px", fontWeight: 600 }}
                >
                  Invoicing Advanced
                </p>
              </div>
            </div>
          </div>
          <hr className="m-0"></hr>
          <p style={{ color: "#6E7491", padding:'15px 0px 4px 23px', fontSize:'14px'}}>Pending Invoice Approvals as of : {formatDate(countDate)} </p>
          <hr className="m-0"></hr>
          <table style={{ margin: "5px 0px 1px 19.2px" ,width:'96%'}}>
            {unApprovedInvoiceCountData?.length > 0 ? (
              unApprovedInvoiceCountData?.map((el: any) => {
                return (
                  <>
                    <tr
                      style={{ fontSize: "16px", fontWeight: "500" }}
                    ><td colSpan={3} style={{paddingTop:'13px', paddingBottom:'5px'}}>{`${el?.client_name} (CC-${el?.client_code})`}</td></tr>
                    <tr
                      style={{
                        fontSize: "14px",
                        fontWeight: "500",
                        color: "#6e7491",
                        borderBottom:"1px solid #bfcbe1",
                      }}
                    >
                      <td 
                      >
                        {" "}
                        <p>
                          Expense Entries
                          <span
                            style={{
                              fontSize: "19px",
                              color: "#dd4433",
                              marginRight: "15px",
                              marginLeft:'12px',
                                 textDecoration:'underline',
                                 cursor:'pointer'

                            }}
                            onClick={() => {
                              history.push({
                                pathname: `/invoice-generation/${el?.client_code}#expenses`,
                                state: {
                                  client_code: el?.client_code,
                                  company_name: el?.client_name,
                                  expenseApproval: "0",
                                  expensestartDate: moment(startDate).format('YYYY-MM-DD'),
                                  expenseendDate:  moment(endDate).format('YYYY-MM-DD'),
                                  radioValue:'1'

                                },
                              });
                            }}
                           
                          >
                            {el?.expenses}
                          </span>
                         
                            
                        </p>
                        
                      </td>
                      <td 
                      >
                        {" "}
                        <p>
                          Sales Entries
                          <span
                            style={{
                              fontSize: "19px",
                              color: "#dd4433",
                              marginRight: "15px",
                               marginLeft:'12px',
                               textDecoration:'underline',
                               cursor:'pointer'
                            }}
                            onClick={() => {
                              history.push({
                                pathname: `/invoice-generation/${el?.client_code}#revenues`,
                                state: {
                                  client_code: el?.client_code,
                                  company_name: el?.client_name,
                                  revenueApproval: "0",
                                  revenuestartDate: moment(startDate).format('YYYY-MM-DD'),
                                  revenueendDate:  moment(endDate).format('YYYY-MM-DD'),
                                  revenueRadioValue:'1'
                                },
                              });
                            }}
                          >
                            {el?.revenues}
                          </span>
                            {" "}
                        </p>
                        
                      </td>
                      <td 
                      >
                        {" "}
                        <p>
                          Others Entries
                          <span
                            style={{ fontSize: "19px", color: "#dd4433" ,cursor:'pointer', marginLeft:'12px',                                 textDecoration:'underline'
                            }}
                            onClick={() => {
                              history.push({
                                pathname: `/invoice-generation/${el?.client_code}#others`,
                                state: {
                                  client_code: el?.client_code,
                                  company_name: el?.client_name,
                                  otherApproval: "0",
                                  otherStartDate: moment(startDate).format('YYYY-MM-DD'),
                                  otherEndDate: moment(endDate).format('YYYY-MM-DD'),
                                  otherRadioValue:'1'

                                },
                              });
                            }}
                          >
                            {el?.others}
                          </span>
                        </p>
                      </td>
                    </tr>
                  </>
                );
              })
            ) : (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "70%",
                  flexDirection: "column",
                }}
              >
                <img src={LikeIcon} alt="like-icon" />
                <div
                  className="mt-3"
                  style={{
                    fontSize: "19px",
                    fontWeight: 600,
                    textAlign: "center",
                  }}
                >
                  No Invoice Entries
                </div>
              </div>
            )}
          </table>
        </>
      )}
    </div>
  );
};

export default ShowInvoiceCountAccountInChargeModal;
